import { Provider } from '@angular/core';

import { ClientsService } from '@clients/services/clients.service';
import { CLIENTS_STORE } from '@clients/stores/client.store';

export const CLIENT_PROVIDERS: Provider[] = [ClientsService, CLIENTS_STORE];
